import React from 'react';
import { makeStyles } from '@material-ui/core';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';

import StepConnector from './StepConnector';

const useStyles = makeStyles(() => ({
  stepper: {
    padding: 0
  },
  step: {
    display: 'none'
  }
}));

interface Props {
  step: number;
  totalSteps: number;
}

export default function SignUpStepper(props: Props) {
  const classes = useStyles();
  const steps = [];
  for (let index = 0; index <= props.totalSteps; index++) {
    steps.push(
      <Step key={index} className={classes.step}>
        <StepLabel StepIconComponent={() => null}> </StepLabel>
      </Step>
    );
  }
  return (
    <Stepper className={classes.stepper} activeStep={props.step} connector={<StepConnector />}>
      {steps}
    </Stepper>
  );
}
